import {Box, Button, Divider, Drawer, IconButton, Popover, Typography} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import styled from '@emotion/styled'
import * as React from 'react'
import {useNavigate} from 'react-router-dom'

const StyledDrawer = styled(Drawer)(({theme, width}) => ({
  '& .MuiDrawer-paper': {
    width: width,
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
}))

export default function SideDrawer({
  open,
  setOpen,
  drawerWidth,
  anchor,
  title,
  children,
  subtitle,
  icon,
}) {
  return (
    <StyledDrawer
      anchor={anchor || 'right'}
      open={open}
      onClose={() => setOpen(false)}
      width={drawerWidth || '60%'}
      sx={{
        '& .MuiDrawer-paper': {
          backgroundColor: '#ffffff',
        },
      }}
    >
      {icon ? (
        // Opt-in polished header (icon badge + title + subtitle on one cohesive ground).
        // Only callers that pass `icon` get this; every existing caller keeps the header below.
        <Box sx={{
          px: '30px', py: '16px', display: 'flex', alignItems: 'center', gap: 1.5,
          backgroundColor: '#F7F8FA', borderBottom: '1px solid #E7EAF0',
        }} width={1}>
          <Box sx={{
            width: 42, height: 42, borderRadius: '12px', flex: '0 0 auto', display: 'grid', placeItems: 'center',
            color: '#fff', backgroundImage: 'linear-gradient(135deg,#4F7DF0,#2065D1)', boxShadow: '0 6px 14px rgba(32,101,209,.32)',
          }}>{icon}</Box>
          <Box sx={{minWidth: 0}}>
            <Typography variant='h6' sx={{fontWeight: 800, color: '#212B36', lineHeight: 1.2}}>{title}</Typography>
            {subtitle && <Typography variant='subtitle2' sx={{color: '#637381', fontWeight: 500}}>{subtitle}</Typography>}
          </Box>
          <Box sx={{ml: 'auto'}}><IconButton onClick={() => setOpen(false)}><CloseIcon /></IconButton></Box>
        </Box>
      ) : (
        <>
          <Box
            sx={{
              px: '30px',
              py: '10px',
              background: 'linear-gradient(to right, #FFD700, #FFF8DC)', // Gold to cornsilk
              color: 'black',
            }}
            width={1}
            display='flex'
            alignItems='center'
            justifyContent='space-between'
          >
            <Box>
              <Typography variant='h6'>{title}</Typography>
            </Box>
            <Box>
              <IconButton onClick={() => setOpen(false)} sx={{color: 'black'}}>
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
          <Box
            sx={{
              px: '30px',
              py: '8px',
              backgroundColor: '#f8f9fa',
              borderBottom: '1px solid #e0e0e0',
            }}
          >
            <Typography variant='subtitle2'>{subtitle}</Typography>
          </Box>
        </>
      )}
      <Box
        width={1}
        sx={{
          marginTop: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          marginBottom: 2,
          px: '30px',
          py: '10px',
        }}
      >
        {children}
      </Box>
    </StyledDrawer>
  )
}

export function SideDrawer2({open, setOpen, drawerWidth, anchor, title, children, subtitle}) {
  return (
    <StyledDrawer
      anchor={anchor || 'right'}
      open={open}
      onClose={() => setOpen(false)}
      width={drawerWidth || '60%'}
      sx={{
        '& .MuiDrawer-paper': {
          width: drawerWidth || '60%',
          boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.3)',
          backgroundColor: '#f7f9fc',
        },
      }}
    >
      <Box
        sx={{
          px: '30px',
          py: '10px',
          backgroundColor: '#07ff23b0',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant='h6'>{title}</Typography>
        <IconButton onClick={() => setOpen(false)} sx={{color: '#fff'}}>
          <CloseIcon />
        </IconButton>
      </Box>
      {subtitle && (
        <Box sx={{px: '30px', py: '10px', backgroundColor: '#e3f2fd'}}>
          <Typography variant='subtitle2'>{subtitle}</Typography>
        </Box>
      )}
      <Divider />
      <Box
        width={1}
        sx={{
          marginTop: 2,
          px: '30px',
          py: '10px',
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto',
        }}
      >
        {children}
      </Box>
    </StyledDrawer>
  )
}

export function CustomPopover({
  open,
  setOpen,
  anchorOrigin = {vertical: 'bottom', horizontal: 'left'},
  subtitle = '',
  children,
  popoverWidth = '300px',
  popoverProps = {},
}) {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const navigate = useNavigate()

  const handleClose = () => {
    setAnchorEl(null)
    setOpen(false)
  }
  const viewAllHandler = () => {
    setOpen(false)
    navigate('/allupdates')
  }

  return (
    <Popover
      id='custom-popover'
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
      PaperProps={{
        sx: {
          width: popoverWidth,
          boxShadow: '0 8px 28px rgba(33,43,54,0.16)',
          mt: 1.5,
          borderRadius: '12px',
          border: '1px solid #DFE3E8',
          overflow: 'hidden',
        },
      }}
      {...popoverProps}
    >
      {subtitle && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            px: 2.5,
            py: 1.75,
            backgroundColor: '#212B36',
            position: 'sticky',
            top: 0,
            zIndex: 1,
          }}
        >
          <img src='/img/logo-prozo.png' width='22' height='32' alt='logo' id='home' />
          <Typography
            sx={{fontFamily: 'Poppins, sans-serif', fontSize: '0.95rem', fontWeight: 600, color: '#fff'}}
          >
            {subtitle}
          </Typography>
        </Box>
      )}
      <Box
        sx={{
          maxHeight: '70vh',
          minHeight: '40vh',
          overflowY: 'auto',
          p: 2,
          bgcolor: '#F9FAFB',
          scrollbarWidth: 'thin',
          scrollbarColor: 'rgba(0, 0, 0, 0.2) transparent',
          '&::-webkit-scrollbar': {
            width: '6px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            borderRadius: '10px',
            transition: 'background-color 0.3s',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
          },
        }}
      >
        {children}
      </Box>
      <Box sx={{px: 2, py: 1.5, borderTop: '1px solid #DFE3E8', bgcolor: '#fff'}}>
        <Button
          fullWidth
          variant='contained'
          onClick={viewAllHandler}
          sx={{
            textTransform: 'none',
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 600,
            borderRadius: '8px',
            boxShadow: 'none',
            '&:hover': {boxShadow: 'none'},
          }}
        >
          View All
        </Button>
      </Box>
    </Popover>
  )
}
